
import _ from 'underscore';
import BaseView from './base-view';
import Timer from '../utils/timer';
import gsap from 'gsap';

class HeaderBlockGallery extends BaseView {
	//el() { return '#page-header' },

	events() {
		return {

		};
	}

	postInitialize() { return {}; }

	bindings() { return {}; }

	listeners() {
		this.listenTo(this.pubSub, 'onHidden', this.handleOnHidden, this);
		this.listenTo(this.pubSub, 'onVisible', this.handleOnVisible, this);
	}

	render() {
		var self = this;
		this.activeTimer = false;
		this.$itemsHolder = $('.marquee-items-holder', this.$el);
		this.$items = $('.marquee-item', this.$el);

		// show the first item
		setTimeout(function () {
			self.$items.eq(0).removeClass('entering');
		}, 100);

		// handle resize, even if there's only one item
		$(window).on('resize.marqueefade', function () {
			self.handleResize();
		});

		// no need to do anything for a single header item
		if (this.$items.length <= 1) {
			this.$el.addClass('ready');
			// trigger resize
			$(window).trigger('resize.marqueefade');
			return this;
		}

		this.curIndex = 0;
		this.totalItems = this.$items.length;

		// now make all items position-absolute for transitioning.
		this.$el.addClass('ready');

		// now start timer
		this.startTimer();
		this.activeTimer = true;
		this.timerPaused = false;
		// trigger resize
		$(window).trigger('resize.marqueefade');

		return this;
	}

	startTimer() {
		var self = this;
		// start the timer and define the timer actions
		this.timer = new Timer(function () {
			// get indexes
			var oldIndex = self.curIndex,
				newIndex = oldIndex + 1;

			if (newIndex >= self.totalItems) {
				newIndex = 0;
			}
			// animate
			self.$items.eq(oldIndex).addClass('exiting');
			gsap.to(self.$items[oldIndex], {
				duration: 0.3, autoAlpha: 0, onComplete: function () {
					// remove exiting class
					self.$items.eq(oldIndex).removeClass('exiting');
					// update container translateX to put new child element in viewport
					self.$itemsHolder.css('transform', 'translateX(-' + (newIndex * 100 / self.totalItems) + '%)');
				}
			});


			self.$items.eq(newIndex).addClass('entering');
			gsap.to(self.$items[newIndex], {
				duration: 0.3, autoAlpha: 1, delay: 0.3, onComplete: function () {
					self.$items.eq(newIndex).removeClass('entering');
				}
			});
			// update curIndex
			self.curIndex = newIndex;
		},
			{
				delay: 8000, // 8 second delay
				repeat: 9999,
			});
	}

	handleResize() {
		var tHeight = 0;
		_.each(this.$items, function (item) {
			if (item.clientHeight > tHeight) {
				tHeight = item.clientHeight;
			}
		});
		this.$el.css('minHeight', tHeight);
	}

	/**
	* Handle handleOnHidden events
	*/
	handleOnHidden() {
		if (this.activeTimer) {
			this.timer.pause();
			this.timerPaused = true;
		}
	}

	/**
	* Handle handleOnVisible events
	*/
	handleOnVisible() {
		if (this.activeTimer) {
			if (this.timerPaused) {
				// resume the timer - minimum of 1 second
				this.timer.resume(1000);
				this.timerPaused = false;
			}
		}
	}

	cleanup() {
		if (this.timer) {
			this.timer.destroy();
		}
	}

}

export default HeaderBlockGallery;